import { CatOrDog, PetPedigree } from '../types/pet';

import { petSubTypes } from '../data/pet';

export const findSubTypeByValueAndType = (subTypeValue: PetPedigree, type: CatOrDog) =>
  petSubTypes.find((subType) => subType.pedigree === subTypeValue && subType.type === type);
